import { toast } from "react-toastify";
import axios from "axios";
import { base_url } from "../../components/Transformation/Transformations";
import { GET_USER_BYEMAIL, getUserByEmail } from "./user.action";
import moment from "moment-timezone";

export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_LOG_OUT = "SET_LOG_OUT";

export const Logout = () => (dispatch) => {
  return dispatch({
    type: SET_LOG_OUT,
    payload: null,
  });
};

export const forgotPassword = (email, navigation) => (dispatch) => {
  axios
    .post(base_url + "/clubusers/forget_password", {
      username: email,
    })
    .then((response) => {
      toast.success("Password was sent to your email successfully!", {
        position: "bottom-right",
      });
      navigation("/login");
    })
    .catch((error) => {
      const message = error.response
        ? error.response.data.message
        : "An unexpected error occurred";
      toast.error(message, {
        position: "bottom-right",
      });
    });
};

export const register = ({
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  timeZone,
  navigation,
}) => (dispatch) => {
  if (timeZone === 'GUESS') {
    timeZone = moment.tz.guess();
  }

  return axios
    .post(base_url + "/clubusers/", {
      first_name: firstName,
      last_name: lastName,
      email,
      preferred_name: firstName,
      password,
      confirm_password: confirmPassword,
      timezone: timeZone,
    }, {
      withCredentials: true
    })
    .then((response) => {
      if (response.status === 201) {
        toast.success("Successfully registered!", {
          position: "bottom-right",
        });

        // Dispatch login action and return the status
        return dispatch(login({ email, password, navigation }));
      }
      return { status: response.status }; // Return status for other cases
    })
    .catch((error) => {
      const status = error.response ? error.response.status : 500;
      return { status }; // Return the status
    });
};


export const login = ({ email, password, navigation }) => (dispatch) => {
  return axios
    .post(base_url + "/clubusers/login", {
      username: email,
      password,
    })
    .then(async (response) => {
      const status = response.status;  // Capture HTTP status

      toast.success("You have logged in successfully.", {
        position: "bottom-right",
      });

      const token = response.data.token;
      const mail = response.data.user;

      localStorage.setItem("token", token);
      localStorage.setItem("mail", mail);

      await dispatch({
        type: SET_AUTH_TOKEN,
        payload: response.data,
      });

      // Fetch user profile (handles both email & username lookups)
      return dispatch(
        getUserByEmail({ token, mail, loginResponseData: response.data })
      )
        .then(() => {
          navigation("/user/profile");
          return { status, data: response.data }; // Return the status and data
        })
        .catch(() => {
          navigation("/user/profile");
          return { status, data: response.data };
        });
    })
    .catch((error) => {
      const status = error.response ? error.response.status : 500;
      return { status }; // Return the error status
    });
};

export const impersonateUser = (targetUsername) => (dispatch) => {
  const currentToken = localStorage.getItem("token");
  const currentMail = localStorage.getItem("mail");
  const currentUserData = localStorage.getItem("userData");

  return axios
    .post(
      base_url + "/clubusers/impersonate",
      { username: targetUsername },
      {
        headers: {
          Authorization: "Token " + currentToken,
        },
      }
    )
    .then(async (response) => {
      // Store original admin details if not stored yet
      if (!localStorage.getItem("admin_original_token")) {
        localStorage.setItem("admin_original_token", currentToken);
        localStorage.setItem("admin_original_mail", currentMail);
        if (currentUserData) {
          localStorage.setItem("admin_original_userData", currentUserData);
        }
      }

      const newToken = response.data.token;
      const targetMail = response.data.user;

      localStorage.setItem("token", newToken);
      localStorage.setItem("mail", targetMail);

      toast.info(`Switched to impersonated user: ${targetMail}`, {
        position: "bottom-right",
      });

      dispatch({
        type: SET_AUTH_TOKEN,
        payload: response.data,
      });

      // Retrieve target user profile data
      return axios
        .get(`${base_url}/clubusers/?email=${targetMail}`, {
          headers: {
            Authorization: "Token " + newToken,
          },
        })
        .then((userResponse) => {
          const targetUserData = userResponse.data.results[0];
          localStorage.setItem("userData", JSON.stringify(targetUserData));
          dispatch({
            type: GET_USER_BYEMAIL,
            payload: targetUserData,
          });
          window.location.href = "/user/profile";
        });
    })
    .catch((error) => {
      const message =
        error.response?.data?.status ||
        error.response?.data?.error ||
        "Failed to impersonate user.";
      toast.error(message, { position: "bottom-right" });
    });
};

export const stopImpersonating = () => () => {
  const origToken = localStorage.getItem("admin_original_token");
  const origMail = localStorage.getItem("admin_original_mail");
  const origUserData = localStorage.getItem("admin_original_userData");

  if (origToken && origMail) {
    localStorage.setItem("token", origToken);
    localStorage.setItem("mail", origMail);
    if (origUserData) {
      localStorage.setItem("userData", origUserData);
    }
    localStorage.removeItem("admin_original_token");
    localStorage.removeItem("admin_original_mail");
    localStorage.removeItem("admin_original_userData");

    toast.info("Exited impersonation mode.", { position: "bottom-right" });
    window.location.href = "/user/profile";
  }
};


